import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Card,
  Button,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import api, { API_BASE_URL } from "../utils/api";
import WorkIcon from "@mui/icons-material/Work";
import { keyframes } from "@emotion/react"; // 🔥 Import animation

// 🔄 Fade-in animation definition
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -60%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

const OrdersPreview = () => {
  const [myWorkOrders, setMyWorkOrders] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const id = localStorage.getItem("currentUserId");
      if (id) {
        fetchUserWorkOrders(id);
      } else {
        console.warn("No user found in localStorage or missing userId.");
      }
    }, 200);
  }, []);

  const fetchUserWorkOrders = async (userId) => {
    try {
      const res = await api.get(`/getWorkOrders`);
      const assigned = res.data.filter(
        (order) => String(order.assign_to) === String(userId)
      );
      if (assigned.length > 0) {
        setMyWorkOrders(assigned);
        setModalOpen(true);
      }
    } catch (err) {
      console.error("Failed to fetch user work orders:", err);
    }
  };

  const handleClose = () => setModalOpen(false);

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      sx={{
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0,0,0,0.3)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 500 },
          bgcolor: "background.paper",
          borderRadius: 4,
          boxShadow: 6,
          p: 4,
          animation: `${fadeIn} 0.3s ease-in-out`,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
          🔔 Work Orders Assigned to You
        </Typography>

        {myWorkOrders.slice(0, 3).map((order) => (
          <Card
            key={order.order_id}
            sx={{
              p: 2,
              mb: 2,
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: "#f9f9f9",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <WorkIcon sx={{ color: "#1976d2", mr: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">
                WO-{order.order_id}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {order.description}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Created: {new Date(order.created_at).toLocaleDateString()}
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Button
                component={Link}
                to={`/home/workorders/${order.order_id}`}
                size="small"
                variant="contained"
                color="primary"
                
              >
                View Details
              </Button>
            </Box>
          </Card>
        ))}

        {myWorkOrders.length > 3 && (
          <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
            ...and {myWorkOrders.length - 3} more assigned to you.
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />
        <Box sx={{ textAlign: "right" }}>
          <Button onClick={handleClose} variant="outlined">
            Dismiss
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OrdersPreview;
